var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"phone text-block"},[_c('div',{staticClass:"phone-icon"}),_c('h3',{staticClass:"phone-text",domProps:{"innerHTML":_vm._s(_vm.$nl2br(_vm.item.content))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }